export default "/assets/images/rejoice-video.mp4?135f19a62a247b2ca2e045c72bfba5ae";